export default __webpack_public_path__ + "static/media/excel.1bd0e938.svg";